/**
 * Plan Selector — selling_plan injector
 *
 * Finds the Shopify product form and injects/updates a hidden
 * selling_plan input when the user selects a subscription plan.
 */
(function () {
  'use strict';

  document.querySelectorAll('.plan-selector').forEach(function (container) {
    if (container.dataset.wired) return;
    container.dataset.wired = 'true';

    var radios = container.querySelectorAll('input[type="radio"]');
    var cards = container.querySelectorAll('.plan-selector__card');

    /* --- Locate the product form --- */
    var form =
      container.closest('form[data-type="add-to-cart-form"]') ||
      (container.closest('.shopify-section') || document).querySelector(
        'form[data-type="add-to-cart-form"]'
      );

    /* --- Create / find hidden selling_plan input --- */
    var spInput = null;
    if (form) {
      spInput = form.querySelector('input[name="selling_plan"]');
      if (!spInput) {
        spInput = document.createElement('input');
        spInput.type = 'hidden';
        spInput.name = 'selling_plan';
        form.appendChild(spInput);
      }
    }

    /* --- Find quantity selector elements --- */
    var section = container.closest('.shopify-section') || document;
    var qtyInput = section.querySelector('input[name="quantity"]');
    var qtyWrapper = qtyInput ? qtyInput.closest('.quantity-selector-wrapper') : null;
    var qtyButtons = qtyWrapper ? qtyWrapper.querySelectorAll('button') : [];

    /* --- Update visual + hidden input + quantity --- */
    function select(radio) {
      if (spInput) spInput.value = radio.value || '';

      var planType = radio.getAttribute('data-plan-type');
      var planQty = radio.getAttribute('data-quantity');

      if (qtyInput && planQty) {
        qtyInput.value = planQty;
        /* Trigger blur to sync Horizon's quantity-selector-component internal state */
        qtyInput.dispatchEvent(new Event('focus', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('blur', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      /* Lock quantity selector for quarterly (fixed 3-unit pack) */
      var isLocked = planType === 'quarterly';
      if (qtyInput) qtyInput.readOnly = isLocked;
      qtyButtons.forEach(function (btn) { btn.disabled = isLocked; });
      if (qtyWrapper) {
        qtyWrapper.style.opacity = isLocked ? '0.5' : '';
        qtyWrapper.style.pointerEvents = isLocked ? 'none' : '';
      }

      cards.forEach(function (c) {
        c.classList.remove('is-selected');
      });
      var card = radio.closest('.plan-selector__card');
      if (card) card.classList.add('is-selected');
    }

    /* --- Radio change listener --- */
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        select(this);
      });
      if (radio.checked) select(radio);
    });

    /* --- Make entire card clickable --- */
    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('a, button')) return;
        var radio = card.querySelector('input[type="radio"]');
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  });
})();
